import "@/components/dashboard/widgets/job_alerts/widget.scss";
import { SubscriptionCountProvider } from "@components/job_alerts/header.tsx";
import { JobAlertsList } from "@components/dashboard/widgets/job_alerts/list.tsx";
import { Header } from "@components/dashboard/widgets/job_alerts/header.tsx";

const JobAlerts = () => (
  <>
    <SubscriptionCountProvider>
      <Header />
    </SubscriptionCountProvider>
    <JobAlertsList />
  </>
);

export default JobAlerts;
